import HelpLinkCheck from "./HelpLinkCheck"

export const HelpDropdownMenu = ({onLinkClick}) => {
    return (
        <div className="d-flex menu menu-sub menu-sub-dropdown menu-rounded menu-gray-800 menu-state-bg menu-state-color fw-semibold py-4 fs-6 w-275px">
            <div className="menu-item px-3">
                <div className="menu-content d-flex align-items-center px-3">
                    <div className="d-flex flex-column">
                        <div className="fw-bold d-flex align-items-center fs-5">Help</div>
                    </div>
                </div>
            </div>
            <div className="menu-item px-5">
                <HelpLinkCheck url="https://oars-health.com/" className="menu-link px-5" />
            </div>
            <div className="separator my-2"></div>
            <div className="menu-item px-5">
                <a href="mailto:UMMS-OARS-support@umm.edu?subject=Support Request" className="menu-link px-5">
                    <span className="menu-icon">
                        <i className="fas fa-envelope fs-2 text-primary"></i>
                    </span>
                    <span>Contact Us (mail to)</span>
                </a>
            </div>
            <div className="separator my-2"></div>
            <div className="menu-item px-5">
                <div>UMMS-OARS-support@umm.edu</div>
                <div>UMMS HelpDesk Tel: 410-328-4357</div>
            </div>
        </div>
    )
}

export default HelpDropdownMenu
